__turbopack_context__.v({
  "appDownload": "HeroSection-module-scss-module__A16Zmq__appDownload",
  "appDownloadSeparator": "HeroSection-module-scss-module__A16Zmq__appDownloadSeparator",
  "badgeCheck": "HeroSection-module-scss-module__A16Zmq__badgeCheck",
  "badgeLive": "HeroSection-module-scss-module__A16Zmq__badgeLive",
  "container": "HeroSection-module-scss-module__A16Zmq__container",
  "content": "HeroSection-module-scss-module__A16Zmq__content",
  "copy": "HeroSection-module-scss-module__A16Zmq__copy",
  "eyebrow": "HeroSection-module-scss-module__A16Zmq__eyebrow",
  "eyebrowSeparator": "HeroSection-module-scss-module__A16Zmq__eyebrowSeparator",
  "hpv2Blink": "HeroSection-module-scss-module__A16Zmq__hpv2Blink",
  "hpv2DemoBounce": "HeroSection-module-scss-module__A16Zmq__hpv2DemoBounce",
  "hpv2DemoFadeIn": "HeroSection-module-scss-module__A16Zmq__hpv2DemoFadeIn",
  "hpv2DemoProgress": "HeroSection-module-scss-module__A16Zmq__hpv2DemoProgress",
  "hpv2DemoScaleIn": "HeroSection-module-scss-module__A16Zmq__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "HeroSection-module-scss-module__A16Zmq__hpv2DemoSlideIn",
  "hpv2FadeLeft": "HeroSection-module-scss-module__A16Zmq__hpv2FadeLeft",
  "hpv2FadeRight": "HeroSection-module-scss-module__A16Zmq__hpv2FadeRight",
  "hpv2FadeUp": "HeroSection-module-scss-module__A16Zmq__hpv2FadeUp",
  "hpv2FloatA": "HeroSection-module-scss-module__A16Zmq__hpv2FloatA",
  "hpv2FloatB": "HeroSection-module-scss-module__A16Zmq__hpv2FloatB",
  "hpv2HeroFadeIn": "HeroSection-module-scss-module__A16Zmq__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "HeroSection-module-scss-module__A16Zmq__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "HeroSection-module-scss-module__A16Zmq__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "HeroSection-module-scss-module__A16Zmq__hpv2PriceShimmer",
  "hpv2PulseDot": "HeroSection-module-scss-module__A16Zmq__hpv2PulseDot",
  "hpv2ScaleUp": "HeroSection-module-scss-module__A16Zmq__hpv2ScaleUp",
  "hpv2TruckDriveIn": "HeroSection-module-scss-module__A16Zmq__hpv2TruckDriveIn",
  "left": "HeroSection-module-scss-module__A16Zmq__left",
  "quoteFormWrap": "HeroSection-module-scss-module__A16Zmq__quoteFormWrap",
  "right": "HeroSection-module-scss-module__A16Zmq__right",
  "section": "HeroSection-module-scss-module__A16Zmq__section",
  "storeButton": "HeroSection-module-scss-module__A16Zmq__storeButton",
  "storeButtons": "HeroSection-module-scss-module__A16Zmq__storeButtons",
  "subtitle": "HeroSection-module-scss-module__A16Zmq__subtitle",
  "title": "HeroSection-module-scss-module__A16Zmq__title",
  "truckBadge": "HeroSection-module-scss-module__A16Zmq__truckBadge",
  "truckBadgeAvailable": "HeroSection-module-scss-module__A16Zmq__truckBadgeAvailable",
  "truckBadgeVerified": "HeroSection-module-scss-module__A16Zmq__truckBadgeVerified",
  "truckFrame": "HeroSection-module-scss-module__A16Zmq__truckFrame",
});
